module.exports = __webpack_public_path__ + "OFF_ClimateLabel_FI-03-78ea0f5cbd62ab1f208d04f180bb9f62.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/OFF_ClimateLabel_FI-03.png
// module id = 75
// module chunks = 0